// extracted by css-extract-rspack-plugin
export default {"upsellInlineBanner":"uLhwik2iHswfFuiA","star":"PnoJwp2iOdMW0Iyu"};